import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getAllResearch(_obj, params) {
    const res = await axios.get(`api/research/`, { params });
    return res.data;
  },

  async getResearch(_obj, id) {
    const res = await axios.get(`api/research/${id}/`);
    return res.data;
  },

  async createResearch(_obj, data) {
    return axios.post(`api/research/`, data);
  },

  async updateResearch(_obj, { id, data }) {
    return axios.patch(`api/research/${id}/`, data);
  },

  async deleteResearch(_obj, id) {
    return axios.delete(`api/research/${id}/`);
  },

  // Public: research listings featured for a university (powers <uni_listing>).
  async getResearchForUni(_obj, params) {
    const res = await axios.get(`api/research/research-for-uni/`, { params });
    return res.data;
  },

  // Public: research listings posted by an organization (powers the org's own site).
  async getOrgResearch(_obj, params) {
    const res = await axios.get(`api/research/org-research/`, { params });
    return res.data;
  },
};

export const research = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
